module.exports = __webpack_public_path__ + "static/media/BarcelonaActiva1.2a3364a9.png";